import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=50a2789d&"
import script from "./ButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./ButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonGroup.vue?vue&type=style&index=0&id=50a2789d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports